import { FC, useCallback, useMemo } from "react";
import { NavLink } from "react-router";
import { styled } from "styled-components";
import { routes } from "../../App";
import { useGetAgentStateQuery, useLogoutMutation } from "../../redux/apis/blenderApi";
interface IProps {
  activeTabKey: string;
  onCloseMenu?(): void;
}

const SideMenu: FC<IProps> = ({ activeTabKey, onCloseMenu }) => {
  const { data: agentState } = useGetAgentStateQuery();
  const [logoutOfBlender] = useLogoutMutation();

  const filteredTabs = useMemo(
    () => {
      const tabs = [
        {
          key: routes.home,
          title: "Home",
        },
        {
          key: routes.businessUnits,
          title: "Business Units",
        },
        {
          key: routes.taskHistory,
          title: "Task History",
        },
        {
          key: routes.loggedOut,
          title: "Log out",
        },
      ];

      if (!agentState?.allowBusinessUnitSelection)
        return tabs.filter(tab => tab.key !== routes.businessUnits);
      else
        return tabs;
    },
    [agentState?.allowBusinessUnitSelection],
  );

  const handleLogOut = useCallback(
    () => {
      void logoutOfBlender();
      onCloseMenu?.();
    },
    [logoutOfBlender, onCloseMenu],
  );

  return (
    <StyledSideBar>
      {
        filteredTabs.map(item =>
          item.key === routes.loggedOut
            ? <StyledListItem key={item.key} $isActive={false} onClick={handleLogOut}>{item.title}</StyledListItem>
            : <StyledNavLink
                key={item.key}
                to={item.key}
                onClick={onCloseMenu}
              >
                <StyledListItem $isActive={activeTabKey === item.key}>{item.title}</StyledListItem>
              </StyledNavLink>,
        )
      }
    </StyledSideBar>
  );
};

export default SideMenu;

const StyledSideBar = styled.div`
  width: 100%;
  background-color: ${p => p.theme.colorBgLayout};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  font-size: ${p => p.theme.fontSizeHeading3}px;
`;

const StyledListItem = styled.div<{ $isActive: boolean }>`
  width: 100%;
  background-color: ${p => p.$isActive ? p.theme.colorBgContainer : "inherit"};
  color: ${p => p.$isActive ? p.theme.colorPrimary : p.theme.colorText};
  padding: ${p => p.theme.padding}px;
  border-left: ${p => `${p.theme.lineWidth * 2}px solid ${p.$isActive ? p.theme.colorPrimary : p.theme.colorBgLayout}`};
  cursor: pointer;
`;

const StyledNavLink = styled(NavLink)`
  width: 100%;
  text-decoration: none;
  color: inherit;
`;
